import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const flashFlood24hEULegendPerLevel = (t, level) => {
  return [
    `${t("levels.noData")} : (pp < 0)`,
    `${t("levels.low")} : (0 ≤ pp < 2)`,
    `${t("levels.moderate")} : (2 ≤ pp < 5)`,
    `${t("levels.significant")} : (5 ≤ pp < 7.5)`,
    `${t("levels.high")} : (pp ≥ 7.5)`,
  ][level];
};

export const flashFlood24hEULegendLevels = () => {
  return [0, 2, 5, 7.5, 100];
  // 4 numerical intervals for normal legend (1,2,3,4)
  // Other values are considered as "no data"
};

const FlashFlood24hEULegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.flashflood")} (ITA) - 24h</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>
        {flashFlood24hEULegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#d0efff")}></span>
        {flashFlood24hEULegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#187bcd")}></span>
        {flashFlood24hEULegendPerLevel(t, 3)}
      </div>
      <div>
        <span style={legendItemStyle("#03254c")}></span>
        {flashFlood24hEULegendPerLevel(t, 4)}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pp level = precipitation level, measured in mm/h
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default FlashFlood24hEULegend;
